import LogoPrimaryStaging from '@rhg/../public/_n/images/logo-primary-staging.svg';
import LogoPrimary from '@rhg/../public/_n/images/logo-primary.svg';
import LogoWhiteStaging from '@rhg/../public/_n/images/logo-white-staging.svg';
import LogoWhite from '@rhg/../public/_n/images/logo-white.svg';
import { Environment } from '@rhg/constants';
import useAppConfig from '@rhg/hooks/use-app-config';
import commonMessages from '@rhg/lang/messages/common';
import { ButtonBase, useTheme } from '@rhg/libs/material';
import { routes } from '@rhg/utils/routes';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import AuthenticatedComponent from '../authenticated-component';
import { APP_LOGO_HEIGHT, APP_LOGO_WIDTH } from './types';

const baseLogoProps = {
    role: 'img',
    'data-testid': 'LOGO',
};

interface LogoSvgProps {
    width?: string;
    height?: string;
}
function LogoSvg({ width, height }: LogoSvgProps) {
    const { formatMessage } = useIntl();
    const { NEXT_PUBLIC_ENV: env } = useAppConfig();
    const {
        palette: { mode },
    } = useTheme();
    const logoProps = { ...baseLogoProps, width, height };
    return mode === 'dark' ? (
        env !== Environment.PRODUCTION ? (
            <LogoWhiteStaging
                aria-label={formatMessage(commonMessages['common.logo_alt'])}
                {...logoProps}
            />
        ) : (
            <LogoWhite
                aria-label={formatMessage(commonMessages['common.logo_alt'])}
                {...logoProps}
            />
        )
    ) : env !== Environment.PRODUCTION ? (
        <LogoPrimaryStaging
            aria-label={formatMessage(commonMessages['common.logo_alt'])}
            {...logoProps}
        />
    ) : (
        <LogoPrimary
            aria-label={formatMessage(commonMessages['common.logo_alt'])}
            {...logoProps}
        />
    );
}

export interface AppLogoProps {
    clickable?: boolean;
    onClick?: () => void;
    route?: string;
    width?: string;
    height?: string;
}

export const AppLogo = ({
    onClick,
    clickable = true,
    route = routes.dashboard,
    width = `${APP_LOGO_WIDTH}px`,
    height = `${APP_LOGO_HEIGHT}px`,
}: AppLogoProps) => {
    const { push } = useRouter();

    const handleLogoClicked = () => {
        onClick?.();
        push(route);
    };

    return (
        <AuthenticatedComponent
            fallback={<LogoSvg width={width} height={height} />}
        >
            {clickable ? (
                <ButtonBase
                    onClick={handleLogoClicked}
                    trackButton="BrandLogo"
                    tabIndex={0}
                >
                    <LogoSvg width={width} height={height} />
                </ButtonBase>
            ) : (
                <LogoSvg width={width} height={height} />
            )}
        </AuthenticatedComponent>
    );
};

export default AppLogo;
